import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Hospital: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path fill="#fff" d="M30.761 6.32H17.328v13.434h13.433V6.32Z" />
        <path
          fill="#FF612B"
          d="M25.644 11.433h2.514v3.207h-2.514v2.687h-3.206V14.64H19.75v-3.207h2.687V8.747h3.206v2.686ZM42.284 43.5H5.711a2.422 2.422 0 0 1 2.427-2.427V8.14h7.28V4.5H32.49v3.64h7.28v32.933c1.387 0 2.513 1.04 2.513 2.427Zm-24.96-23.747h13.434V6.32H17.324v13.433Zm5.46 9.1h-6.066v12.22h6.066v-12.22Zm8.494 0H25.21v12.22h6.067v-12.22Z"
        />
        <path
          fill="#002677"
          d="M22.785 28.852H16.72v12.22h6.066v-12.22ZM31.278 28.852H25.21v12.22h6.067v-12.22Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
    </defs>
  </Box>
)
export default Hospital
